export const GETALLCOSTPAGE = 'GETALLCOSTPAGE'
export const GETWAREHOUSEPAGES = 'GETWAREHOUSEPAGES'
export const WAREHOUSEDETAIL = 'WAREHOUSEDETAIL'
export const COSTSETTLEMENT = 'COSTSETTLEMENT'
export const GETRUNNINGPAGE = 'GETRUNNINGPAGE'
export const GETLABELPAGE = 'GETLABELPAGE'
export const GETFILMPAGE = 'GETFILMPAGE'
export const GETCOSTDETAIL = 'GETCOSTDETAIL'
export const GETRETURNPAGE = 'GETRETURNPAGE'
export const GETRETURNDETAIL = 'GETRETURNDETAIL'
export const EXPORTCOSTDETAILS = 'EXPORTCOSTDETAILS'
export const generateCostData = 'generateCostData'
export const GETADISPATCH = 'GETADISPATCH' //  配送仓点 
export const OTHERDETATL = 'OTHERDETATL' // 其他费用详情
export const GETOTHERCOST = 'GETOTHERCOST' // 其他费用新增
export const SUPPLIERGETLISTS = 'SUPPLIERGETLISTS' // 供应商



// WEBPACK FOOTER //
// ./src/store/costMenu/types.js